<template>
  <div class="setting-layout">
    <header class="setting-layout__header">
      <slot name="header">
        <h2
          v-if="headerTitle"
          class="setting-layout__title"
        >{{ headerTitle }}</h2>
      </slot>
    </header>
    <main class="setting-layout__content">
      <slot></slot>
    </main>
    <footer class="setting-layout__footer">
      <slot name="footer">
        <el-button
          v-if="footerText"
          type="primary"
          class="setting-layout__footer-button"
          :loading="loading"
          @click="handleFooterClick"
        >{{ footerText }}</el-button>
      </slot>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'SettingLayout',
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    footerText: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleFooterClick() {
      this.$emit('footer-click');
    },
  },
};
</script>

<style lang="scss" scoped>
.setting-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: #fff;

  &__header {
    padding: 20px;
    border-bottom: 1px solid #ebeef5;
    flex-shrink: 0; // Prevent header from shrinking
  }

  &__title {
    margin: 0;
    font-size: 18px;
    font-weight: 500;
  }

  &__content {
    flex-grow: 1; // Allow content to take available space
    padding: 40px;
    overflow-y: auto; // Add scroll if content overflows
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    border-top: 1px solid #ebeef5;
    text-align: right; // Align button to the right by default
    flex-shrink: 0; // Prevent footer from shrinking
  }

  &__footer-button {
    width: 300px;
  }
}
</style>
